var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getAvailablePlanTypes().length > 0
    ? _c("div", { staticClass: "plans-wrapper" }, [
        _c("div", { staticClass: "plans-wrapper-title" }, [
          _vm._v(_vm._s(_vm.$t("billing.plans"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "plans-wrapper-content" },
          _vm._l(_vm.getAvailablePlanTypes(), function (type) {
            return _c("PlanItem", { key: type, attrs: { type: type } })
          }),
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }